export var Radio = {
    baseStyle: {},
    sizes: {},
    variants: {},
    defaultProps: { size: 'md' },
};
